import { render } from "./PlatformBex.vue?vue&type=template&id=d81f5378&scoped=true&ts=true"
import script from "./PlatformBex.vue?vue&type=script&lang=ts"
export * from "./PlatformBex.vue?vue&type=script&lang=ts"

import "./PlatformBex.vue?vue&type=style&index=0&id=d81f5378&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81f5378"]])

export default __exports__